module.exports = __webpack_public_path__ + "components/flag/static/square/tc-ae084049c13be56728824a6c73258c69.svg";